<template>
	<div
		v-if="visible"
		class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
	>
		<div
			class="bg-white backdrop-blur-md rounded-2xl sm:rounded-3xl shadow-xl p-6 w-full max-w-md relative"
		>
			<!-- Header -->
			<div class="flex justify-between items-center mb-4">
				<h2 class="text-xl font-bold text-gray-900">{{ title }}</h2>
				<button
					@click="$emit('close')"
					class="text-gray-500 hover:text-gray-700 text-2xl leading-none focus:outline-none"
				>
					&times;
				</button>
			</div>

			<!-- Body -->
			<div class="mb-6">
				<slot />
				<div class="mt-3">
					<label class="block mb-1 font-medium text-gray-700">
						Adjust Benefit Limit
					</label>
					<input
						v-model.number="limit"
						type="number"
						class="w-full h-12 px-4 text-base text-gray-800 border-2 border-gray-200 rounded-xl bg-white/70 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-300 transition-all duration-300"
						placeholder="Enter benefit limit"
					/>
				</div>
			</div>

			<!-- Footer -->
			<div class="flex justify-end gap-3">
				<button
					@click="$emit('close')"
					class="flex items-center justify-center h-12 px-6 text-sm font-semibold text-blue-600 border-2 border-blue-200 rounded-full bg-white/70 backdrop-blur-sm hover:bg-blue-50 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300"
				>
					Cancel
				</button>
				<button
					@click="handleConfirm"
					class="flex items-center justify-center h-12 px-6 text-sm font-semibold text-white bg-blue-600 rounded-full shadow-lg hover:bg-blue-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transform hover:scale-[1.02] transition-all duration-300"
				>
					Confirm
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	props: {
		title: {
			type: String,
			default: 'Adjust Benefit Limit',
		},
		visible: {
			type: Boolean,
			required: true,
		},
		benefit: {
			type: Object,
			default: () => ({
				benefitType: '',
				amount: 0,
				benefitLimit: { defaultLimit: 0 },
				benefitSystemRef: '',
				benefit_category_name: '',
			}),
		},
	},
	data() {
		return {
			limit:
				this.benefit.amount ||
				(this.benefit.benefitLimit &&
					this.benefit.benefitLimit.defaultLimit) ||
				0,
		};
	},
	watch: {
		benefit: {
			handler(newVal) {
				if (newVal) {
					this.limit =
						newVal.amount ||
						(newVal.benefitLimit &&
							newVal.benefitLimit.defaultLimit) ||
						0;
				}
			},
			immediate: true,
			deep: true,
		},
	},
	computed: {
		...mapState('benefits', ['selectedBenefits']),
	},
	methods: {
		...mapActions('benefits', ['setBenefitsData', 'removeBenefit']),
		handleConfirm() {
			// Prepare updated benefit data
			const updatedBenefit = {
				benefitSystemRef: this.benefit.benefitSystemRef,
				benefit_category_name: this.benefit.benefit_category_name,
				benefitType: this.benefit.benefitType,
				params: {
					limit: Number(this.limit),
				},
			};

			// Update Vuex store
			this.setBenefitsData(updatedBenefit);

			// Emit confirm event to parent
			this.$emit('confirm', {
				...this.benefit,
				amount: Number(this.limit),
			});

			// Emit close event to ensure modal closes after confirm
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
.backdrop-blur-md {
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
}

@media (max-width: 640px) {
	.p-6 {
		padding: 1rem;
	}
	.text-xl {
		font-size: 1.125rem;
	}
	.h-12 {
		min-height: 48px;
	}
}

@media (prefers-reduced-motion: reduce) {
	.transition-all {
		transition: none;
	}
}
</style>
